import PageWrapper from "./pageWrapper";

export default PageWrapper;
